export default "<div class=\"slo-page\">\n   Could not find the page you were looking for\n</div>"